import { FORMULA_EDITOR_CONTENT, FORMULA_EDITOR_DASHBOARD_VARIABLES } from "./FormulaEditorAction";

/**
 * 
 * @param {*} state 
 * @param {*} action 
 * @returns 
 * 
 * Reducer for Formula Editor content
 */
export default function FormulaEditorReducer(
  state = {
    contentObject: {
      visible: false,
      code: "",
      column: {},
      selectedFormula: {},
      editorTitle: "",
      expression: false,
      isExpressionAvailable: false,
      uniqeColumnId: "",
      onApply: null
    },
    dashboardVariables: []
  },
  action
) {
  switch (action.type) {
    case FORMULA_EDITOR_CONTENT :
      return {
        ...state,
        contentObject: {
          visible: action.payload.visible ? action.payload.visible : false,
          code: action.payload.code ? action.payload.code : "",
          column: action.payload.column ? action.payload.column : {},
          selectedFormula: action.payload.selectedFormula ? action.payload.selectedFormula : {},
          editorTitle: action.payload.editorTitle ? action.payload.editorTitle : "",
          expression: action.payload.expression !== undefined ? action.payload.expression : state.contentObject.expression,
          isExpressionAvailable: action.payload.isExpressionAvailable !== undefined ? action.payload.isExpressionAvailable : false,
          uniqeColumnId: action.payload.uniqeColumnId !== undefined ? action.payload.uniqeColumnId : "",
          onApply: action.payload.onApply ? action.payload.onApply : null
        }
      };
    case FORMULA_EDITOR_DASHBOARD_VARIABLES:
      return {
        ...state,
        dashboardVariables: action.payload || []
      };
    default:
      return state;
  }
}
